export function downloadFile(
  url: string,
  filename: string,
  target: "_blank" | "_self" = "_self"
): void {
  // Create an <a> element and click on it so the file is downloaded
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.target = target;
  a.click();
}

export function downloadData(data: File | Blob, filename: string): Promise<boolean> {
  return new Promise((resolve) => {
    // Turn data into a data URL, then call downloadFile.
    const reader = new FileReader();

    reader.addEventListener(
      "load",
      () => {
        const dataUrl = reader.result as string;
        downloadFile(dataUrl, filename);
        resolve(true);
      },
      false
    );

    reader.readAsDataURL(data);
  });
}

export function downloadBlob(
  csvString: string,
  filename: string,
  target: "_blank" | "_self" = "_self"
): void {
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  // Create an <a> element and click on it so the file is downloaded
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.target = target;
  a.click();

  // Free the blob from memory; download is already initiated at this point
  URL.revokeObjectURL(url);
}
